/** 个人页主行：优先登录名，未登录回退 Guest 文案。 */
export function oroMxProfileLoginName(
  loginName: string | null | undefined,
  fallback: string,
) {
  const name = loginName?.trim();
  return name || fallback;
}
